import React from 'react';
import Form from 'src/components/controls/forms/Form';
import { AnyObject, FormApi } from 'final-form';
import SearchResult from 'src/models/OwnerSearchResult';
import PropertyUtil from 'src/util/PropertyUtil';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import { RouteComponentProps } from 'react-router';
// import LeaseGenerationForm from 'src/models/leasing/LeaseGenerationForm';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { SelectItem } from 'src/models/common/SelectItem';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
// import FormToggle from 'src/components/controls/forms/redesign/FormToggle';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import Lease from 'src/models/leasehold/Lease';
import Project from 'src/models/Project';
import MathUtil from 'src/util/MathUtil';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import AddOwnershipPages from '../TractComponents/AddOwnershipPages';
import AddOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddOwnership';
import AddWIOwnership from 'src/models/tract_detail/add_ownership_revised/AddWIOwnership';
import Ownership from 'src/models/tract_detail/add_ownership_revised/Ownership';
import ErrorResponse from 'src/models/ErrorResponse';
import PagedResultSet from 'src/models/common/PagedResultSet';
import CardContainer from 'src/components/common/CardContainer.redesign';
import { ODataFilter, ODataFilterOperators, ODataOptions } from 'src/util/ODataBuilder';
import LandContractType from 'src/models/LandContractType';
import * as Constants from 'src/components/common/Constants';

export interface ILeasingOwnerSearchProps {
    onSearchOwners: (searchText: string, ownerType: string) => void;
    navigate: (path: string) => void;
    onGetLeaseGenerationCollection: (ownerLookUpId: number) => void;
    onGetOwnerData: (ownerId: number) => void;
    incrementOwners: (clientNumber: number, projectNumber: number, options: ODataOptions) => void;
    projectData?: Project;
}

export type ILeasingOwnerSearchStateProps = {
    searchResults: PagedResultSet<SearchResult>;
    leaseGenerationCollection: Array<Lease>;
    ownerData: LeaseGenerationOwnerData;
    pathName: string;
};

type LeasingOwnerSearchState = {
    searchString: string;
    selectedOwner: string;
    isOwnerSelected: boolean;
    selectedOwnerId: number;
    searchForOwner: boolean;
    contractType: number;
    leaseType: string | number;
    isProvisional?: boolean;
};

type ILeasingOwnerSearchPageProps = RouteComponentProps<{}> & ILeasingOwnerSearchProps & ILeasingOwnerSearchStateProps;

class LeasingOwnerSearch extends React.Component<ILeasingOwnerSearchPageProps, LeasingOwnerSearchState> {

    constructor(props: ILeasingOwnerSearchPageProps) {
        super(props);

        this.state = {
            searchString: undefined,
            selectedOwner: undefined,
            isOwnerSelected: false,
            selectedOwnerId: 0,
            searchForOwner: true,
            leaseType: 0,
            contractType: 0,
            isProvisional: false,
        };
    }

    private form: FormApi;
    private dialogCreators: dialogCreators;
    // List of Contracts that contain sub-type entities.
    private subTypeAgreements = [
        LandContractType.OilAndGas,
        LandContractType.RightOfWay
    ];

    static contextType = DialogContext;

    public componentDidMount() {
        this.dialogCreators = this.context;
    }

    onSubmit = (values: AnyObject) => {
        if (values !== undefined) {
            this.onLeaseGenerationSelection('new-lease');
        }
    };

    updateSearchString = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentSearchString = e.currentTarget.value;
        this.setState((state) => ({
            ...state,
            searchString: currentSearchString,
        }));

        if (currentSearchString.length > 0) {
            this.props.onSearchOwners(e.currentTarget.value, 'individual');
        }
    };

    onOwnerSelection = (id: number) => {
        this.props.onGetLeaseGenerationCollection(id);
        this.setState({ isOwnerSelected: true, selectedOwnerId: id });
        this.props.onGetOwnerData(id);
    };

    handleNavParams = (fieldState: string) => {
        const leaseTypeCategory = this?.form?.getFieldState(fieldState)?.value;
        if (leaseTypeCategory !== undefined && leaseTypeCategory !== null && String(leaseTypeCategory).length > 0) {
            this.setState({ leaseType: leaseTypeCategory });
            return new URLSearchParams({ leaseType: String(leaseTypeCategory) });
        }
        return new URLSearchParams();
    };

    onLeaseGenerationSelection = (leaseFormId: number | string) => {
        if (this.state.isProvisional) {
            this.createProvisionalOwner();
        }
        const contractType = this?.form?.getFieldState('contractType')?.value;
        this.setState({ contractType: contractType });
        switch (contractType) {
            case LandContractType.OilAndGas:
                const qParams = this.handleNavParams('leaseType');
                this.props.navigate(
                    `${this.props.location.pathname}/lease-generation/ownerId/${this.state.selectedOwnerId}/leases/${leaseFormId}?${qParams}`
                );
                break;
            case LandContractType.SolarLease:
                this.props.navigate(
                    `${this.props.location.pathname}/lease-generation/ownerId/${this.state.selectedOwnerId}/solar-leases/${leaseFormId}`
                );
                break;
            case LandContractType.SurfaceWaiver:
                this.props.navigate(
                    `${this.props.location.pathname}/lease-generation/ownerId/${this.state.selectedOwnerId}/surface-waivers/${leaseFormId}`
                );
                break;
            case LandContractType.BatteryStorage:
                this.props.navigate(
                    `${this.props.location.pathname}/lease-generation/ownerId/${this.state.selectedOwnerId}/battery-storage/${leaseFormId}`
                );
                break;
            case LandContractType.BrineLease:
                this.props.navigate(
                    `${this.props.location.pathname}/lease-generation/ownerId/${this.state.selectedOwnerId}/brine-leases/${leaseFormId}`
                );
                break;
            case LandContractType.RightOfWay:
                const rqParams = this.handleNavParams('leaseType');
                this.props.navigate(
                    `${this.props.location.pathname}/lease-generation/ownerId/${this.state.selectedOwnerId}/right-of-ways/${leaseFormId}?${rqParams}`
                );
                break;
            case LandContractType.CarbonCapture:
                this.props.navigate(
                    `${this.props.location.pathname}/lease-generation/ownerId/${this.state.selectedOwnerId}/carbon-captures/${leaseFormId}`
                );
                break;
            default:
                console.log('No valid path detected. Please add the relevant type');
                break;
        }
    };

    searchResults = () => {
        if (PropertyUtil.SafeGet(() => this.props.searchResults.items.length) > 0 && PropertyUtil.SafeGet(() => this.state.searchString.length) > 0) {
            return this.props.searchResults.items.map((sr, index) => {
                return (
                    <div key={index} className="card" onClick={() => this.onOwnerSelection(sr.id)}>
                        {`${sr.name} - ${sr.type}`}
                    </div>
                );
            });
        } else {
            return <div>No Owners Found</div>;
        }
    };

    // leaseGenerationResults = () => {
    //     if (PropertyUtil.SafeGet(() => this.props.leaseGenerationCollection.length)) {
    //         return this.props.leaseGenerationCollection.map((lg: LeaseGenerationForm, index: number) => {
    //             let leaseData = JSON.parse(lg.leaseFormData);
    //             return (
    //                 <div key={index} className="card" onClick={() => this.onLeaseGenerationSelection(lg.id)}>
    //                     <div>
    //                         {`Document # ${leaseData.docNumber}`}
    //                     </div>
    //                 </div>
    //             );
    //         });
    //     } else {
    //         return (
    //             <div>No Existing Leases Found</div>
    //         );
    //     }
    // }

    leaseTypes = () => {
        if (this.state.contractType === LandContractType.OilAndGas) {
            const ogTypes = [
                { id: 1, name: 'Paid Up Lease' },
                { id: 2, name: 'Top Lease' },
                { id: 3, name: 'Rental Lease' },
            ];
    
            return ogTypes.map((at) => new SelectItem(at.id, at.name));
        }
        if (this.state.contractType === LandContractType.RightOfWay) {
            const rTypes = Object.entries(Constants.rightOfWayLeaseType).map((k) => {
                return { id: k[1], name: `${k[0]} - ${k[1]}` };
            });

            return rTypes;
        }
        return [];
    };

    contractTypes = () => {
        const lTypes = Object.values(Constants.contractTypeRef).map((leaseType) => {
            return new SelectItem(leaseType.value, leaseType.label);
        });

        return lTypes;
    };

    // toggleSearchOwners = (value: string) => {
    //     switch (value) {
    //         case 'Search For Owner':
    //             this.setState({ searchForOwner: true });
    //             break;
    //         case 'Non Existing':
    //             this.setState({
    //                 searchForOwner: false,
    //                 isOwnerSelected: false,
    //                 searchString: undefined,
    //                 selectedOwner: undefined,
    //                 selectedOwnerId: 0,
    //             });
    //             this.form.change('searchString', undefined);
    //             break;
    //         default:
    //             break;
    //     }
    // };

    searchOwnerClass = () => {
        return this.state.searchForOwner ? undefined : 'hidden';
    };

    onFormCreated = (nForm: FormApi) => {
        this.form = nForm;
    };

    validateFields = (values: AnyObject) => {
        let errors: AnyObject = {};

        if (values === undefined || values.agreementType === undefined) {
            errors.agreementType = 'Agreement Type is required!';
        }

        return errors;
    };

    selectedOwnerName = () => {
        const owner = this.props.searchResults.items.find((sr) => sr.id === this.state.selectedOwnerId);

        return <span className="mr-2">{owner?.name}</span>;
    };

    clearSelection = () => {
        this.setState({ isOwnerSelected: false });
        this.setState({ selectedOwnerId: 0 });
    };

    onSelectAgreementNumber = (agreement: AnyObject) => {
        const pathName = this.props.pathName;
        console.log('pathName', pathName, 'agreement', agreement);
    };

    handleProvisionalCheckBoxChange = () => {
        this.setState({ isProvisional: !this.state.isProvisional });
    }

    private createHeader() {
        let headers = {};

        const jwt = this.getJwtToken();

        if (jwt) {
            headers = {
                'content-type': 'application/json',
                Authorization: `Bearer ${jwt}`,
            };
        } else {
            headers = { 'content-type': 'application/json' };
        }

        return headers;
    }

    public getHeader(jwt: string | undefined) {
        const header: RequestInit = {
            headers: this.createHeader(),
            method: 'GET',
            mode: 'cors',
        };
        return header;
    }

    private postHeader(body: object, jwt: string | undefined = undefined) {
        const header: RequestInit = {
            body: JSON.stringify(body),
            headers: this.createHeader(),
            method: 'POST',
            mode: 'cors',
        };
        return header;
    }

    private baseUrl = process.env.REACT_APP_BASE_API_URL + '/';

    public getRequest(url: string, jwt: string | undefined = undefined) {
        return fetch(url, this.getHeader(jwt)).then(this.handleApiCall).catch(this.handleApiError);
    }

    public async postRequest(url: string, body: object, jwt: string | undefined = undefined) {
        return fetch(url, this.postHeader(body, jwt)).then(this.handleApiCall).catch(this.handleApiError);
    }

    getJwtToken = (): string => {
        return localStorage.getItem('jwt') || sessionStorage.getItem('jwt');
    };

    private handleApiCall(value: Response) {
        return new Promise<object>((resolve) => {
            if (value.ok) {
                value
                    .json()
                    .then((body) => resolve(body))
                    .catch(() => resolve(null));
            } else {
                resolve(value.json().then((response: ErrorResponse) => new ErrorResponse(response.messageCode, response.message)));
            }
        });
    }

    handleApiError = () => {
        console.log('api call failed');
    };

    saveAddOwnership = async (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        owner: AddOwnershipData,
        jwt: string
    ) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/save-add-ownership`,
            owner,
            jwt
        ).then(
            (value: object) => {
                const ownerShipId = parseInt(value.toString(), 10);
                if (!isNaN(ownerShipId)) {
                    this.getRequest(
                        `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owners/ownership/${ownerShipId}`
                    ).then(
                        (value2: object) => {
                            const ownerLookupId = parseInt(value2.toString(), 10);
                            if (!isNaN(ownerLookupId)) {
                                const contractType = this?.state.contractType;
                                switch (contractType) {
                                    case LandContractType.OilAndGas:
                                        const qParams = this.handleNavParams('leaseType');
                                        this.props.navigate(`../../${ownerLookupId}/leases/new-lease?${qParams}`);
                                        break;
                                    case LandContractType.SolarLease:
                                        this.props.navigate(`../../${ownerLookupId}/solar-leases/new-lease`);
                                        break;
                                    case LandContractType.SurfaceWaiver:
                                        this.props.navigate(`../../${ownerLookupId}/surface-waivers/new-lease`);
                                        break;
                                    case LandContractType.BatteryStorage:
                                        this.props.navigate(`../../${ownerLookupId}/battery-storage/new-lease`);
                                        break;
                                    case LandContractType.BrineLease:
                                        this.props.navigate(`../../${ownerLookupId}/brine-leases/new-lease`);
                                        break;
                                    case LandContractType.RightOfWay:
                                        const rqParams = this.handleNavParams('leaseType');
                                        this.props.navigate(`../../${ownerLookupId}/right-of-ways/new-lease?${rqParams}`);
                                        break;
                                    case LandContractType.CarbonCapture:
                                        this.props.navigate(`../../${ownerLookupId}/carbon-captures/new-lease`);
                                        break;
                                    default:
                                        break;
                                }
                                window.location.reload();
                            }
                        }
                    );
                }
            }
        );
    };

    onSaveAddOwnership = (values: AddWIOwnership) => {
        let addOwnershipData = new AddOwnershipData();
        addOwnershipData.bolmOwner = values.bolmOwner;
        addOwnershipData.businessOwner = values.businessOwner;
        addOwnershipData.individualOwner = values.individualOwner;
        addOwnershipData.ownership = new Ownership();
        this.saveAddOwnership(
            this.props.projectData.client.clientNumber,
            this.props.projectData.projectNumber,
            0,
            0,
            addOwnershipData,
            this.getJwtToken()
            );
    };

    createProvisionalOwner = () => {
        this.dialogCreators.contract.addContractOwnership(
            DialogList.ADD_WI_OWNERSHIP,
            'Create Provisional Owner',
            undefined,
            undefined,
            this.props.projectData.client.clientNumber,
            this.props.projectData.projectNumber,
            AddOwnershipPages.NewOwnerInfoForm,
            this.props.navigate,
            null,
            this.onSaveAddOwnership
        );
    }

    onUpdateContractType = (e: number) => {
        this.setState({ contractType: e });
    };

    onUpdateLeaseType = (e: string | number) => {
        this.setState({ leaseType: e });
    };

    ownershipList = () => {
        const leaseData: Array<AnyObject> = this.props.leaseGenerationCollection?.map((lg: Lease) => {
            return { id: lg.id, agreementNumber: lg.leaseNumber, tracts: lg.tracts };
        });

        return this.props.ownerData?.tracts?.map((t, index) => {
            return (
                // tslint:disable: max-line-length
                <div
                    key={index}
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        border: 'black solid 1px',
                        backgroundColor: 'white',
                        marginBottom: '.5rem',
                        paddingLeft: '.5rem',
                        paddingRight: '.5rem',
                    }}
                >
                    <div
                        className="mr-1 lh-tenth-width clickable text-blue"
                        onClick={() => {
                            if (!!this.props.projectData && this.props.projectData?.tractTypeId === 2) {
                                this.props.navigate(`sections/${t.sectionNumber}/surface-tracts/${t.tractNumber}`);
                            } else {
                                this.props.navigate(`sections/${t.sectionNumber}/tracts/${t.tractNumber}/horizons/${t.horizonNumber}`);
                            }
                        }}
                    >
                        {t.sectionNumber}.{t.tractNumber}
                    </div>
                    <div className="mr-1" style={{ width: '40%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {t.legalDescription}
                    </div>
                    <div className="mr-1 lh-tenth-width">{t?.grossAcres}</div>
                    <div className="mr-1 lh-tenth-width">{MathUtil.cleanNumber((t?.grossAcres * t?.decimalInterest), 6)}</div>
                    <div className="mr-1 lh-tenth-width">{MathUtil.cleanNumber(t?.decimalInterest)}</div>
                    <div className="lh-tenth-width">{t?.leasedStatus}</div>
                    <div
                        className="lh-tenth-width"
                        onClick={() =>
                            this.onLeaseGenerationSelection(
                                leaseData?.find((data: AnyObject) =>
                                    data?.tracts?.some((tract: AnyObject) => tract.ownershipId === t.ownershipId && tract.includeTract === true)
                                )?.id || 0
                            )
                        }
                    >
                        {leaseData?.find((data: AnyObject) =>
                            data?.tracts?.some((tract: AnyObject) => tract.ownershipId === t.ownershipId && tract.includeTract === true)
                        )?.agreementNumber || 'N/A'}
                    </div>
                </div>
            );
        });
    };

    disableGenerate = () => {
        let contractType = this?.form?.getFieldState('contractType')?.value;

        if (!contractType || (this.subTypeAgreements.includes(this.state.contractType) && !this.form.getFieldState('leaseType')?.value)) {
            return true;
        }

        if (this.state.isProvisional !== true && this.state.selectedOwnerId === 0) {
            return true;
        }

        return false;
    }

    incrementOwners = () => {
        let searchText = '_';
        const options = new ODataOptions();
        if (!!this.state && this.state.searchString !== undefined && this.state.searchString !== '') {
            searchText = this.state.searchString;
        }
        options.addFilter(new ODataFilter('omni', ODataFilterOperators.Contains, searchText));

        this.props.incrementOwners(this.props.projectData.client.clientNumber, this.props.projectData.projectNumber, options);
    };

    public render() {
        const { searchResults } = this.props;
        let isOnLastPage = false;
        if (searchResults) {
            isOnLastPage = searchResults.pageNumber * searchResults.pageSize < searchResults.totalRecords;
        }

        return (
            <Dialog dialogName={DialogList.LEASING_OWNER_SEARCH} title="Generate Contract">
                <div style={{ maxWidth: '80rem', maxHeight: '70vh' }}>
                    <Form onSubmit={this.onSubmit} initialValues={{ searchOwners: 'Search For Owner' }} onFormCreated={this.onFormCreated}>
                        <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                            <legend style={{ marginLeft: '2rem', padding: '0 .5rem' }}>Contract Type</legend>
                        </fieldset>
                        <div>
                            <FormSelect
                                items={this.contractTypes()}
                                name="contractType"
                                label="Contract Type"
                                onChange={(e) => this.onUpdateContractType(e as number)}
                            />
                        </div>

                        {this.subTypeAgreements.includes(this.state.contractType) ? (
                            <div>
                                <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                                    <legend style={{ marginLeft: '2rem', padding: '0 .5rem' }}>Lease Type</legend>
                                </fieldset>
                                <div>
                                    <FormSelect
                                        items={this.leaseTypes()}
                                        name="leaseType"
                                        label="Lease Type"
                                        onChange={(e) => this.onUpdateLeaseType(e)}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div />
                        )}

                        <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                            <legend style={{ marginLeft: '2rem', padding: '0 .5rem' }}>Owner</legend>
                        </fieldset>
                        {!this.state.isOwnerSelected ? (
                            <div>
                                {/* <div className="select-search-owner">
                                    <FormToggle onChange={this.toggleSearchOwners} name="searchOwners" items={['Search For Owner', 'Non Existing']} />
                                </div> */}
                                <div style={{ marginTop: '1.5rem' }} className={this.searchOwnerClass()}>
                                    <FormTextBox name="searchString" label="Enter Owner Name" onChange={this.updateSearchString} />
                                </div>
                            </div>
                        ) : (
                            <div style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
                                {/* <span style={{backgroundColor: '#6393c1', color: 'white'}}>Selected Owner: </span>  */}
                                <span className="clickable mr-2" onClick={this.clearSelection} style={{ color: '#aaa' }}>
                                    <i className="fas fa-times-circle" />
                                </span>
                                <span style={{ borderLeft: '2px solid #aaa', width: '1px' }} className="mr-2" />
                                {this.selectedOwnerName()}
                            </div>
                        )}
                    </Form>

                    {!this.state.isOwnerSelected && this.state.searchForOwner && (
                        <>
                            <CardContainer 
                                showNextPagePanel={isOnLastPage}
                                nextPageAction={this.incrementOwners}
                                style={{ overflow: 'auto', maxHeight: '30rem' }}
                            >
                                <div className="card-list clickable" style={{ borderTop: '2px solid grey', paddingTop: '1rem' }}>
                                    {this.searchResults()}
                                </div>
                            </CardContainer>
                        </>
                    )}

                    {this.state.isOwnerSelected && (
                        <>
                            <div style={{ display: 'flex', justifyContent: 'space-between', paddingLeft: '.5rem', paddingRight: '.5rem' }}>
                                <div className="mr-1 lh-tenth-width">ID</div>
                                <div style={{ width: '40%' }}>Legal Desc</div>
                                <div className="mr-1 lh-tenth-width">Gross</div>
                                <div className="mr-1 lh-tenth-width">Net</div>
                                <div className="mr-1 lh-tenth-width">Int.</div>
                                <div className="lh-tenth-width">Status</div>
                                <div className="lh-tenth-width">Agrmt. #</div>
                            </div>

                            <div style={{ paddingBottom: '1rem', overflow: 'auto', maxHeight: '30rem' }}>
                                {/* {this.props.ownerData?.tracts?.length > 0 && this.props.ownerData.tracts.map((t, index) => {
                                    return (
                                        // tslint:disable: max-line-length
                                        <div key={index} style={{ display: 'flex', justifyContent: 'space-between', border: 'black solid 1px', backgroundColor: 'white', marginBottom: '.5rem', paddingLeft: '.5rem', paddingRight: '.5rem' }}>
                                            <div className="mr-1 lh-tenth-width clickable text-blue" onClick={() => this.props.navigate(`sections/${t.sectionNumber}/tracts/${t.tractNumber}/horizons/${t.horizonNumber}`)}>{t.sectionNumber}.{t.tractNumber}-{t.horizonNumber}</div>
                                            <div className="mr-1" style={{ width: '50%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{t.legalDescription}</div>
                                            <div className="mr-1 lh-tenth-width">{t.grossAcres}</div>
                                            <div className="mr-1 lh-tenth-width">{MathUtil.cleanNumber(t.grossAcres * t.decimalInterest, 6)}</div>
                                            <div className="mr-1 lh-tenth-width">{MathUtil.cleanNumber(t.decimalInterest, 6)}</div>
                                            <div className="lh-tenth-width">{t.leasedStatus}</div>
                                        </div>
                                    );
                                })} */}

                                {this.props.ownerData?.tracts?.length > 0 && <>{this.ownershipList()}</>}
                            </div>
                        </>
                    )}
                    <div className="mt-2 bottom-button" style={{ borderTop: '2px solid grey', paddingTop: '1rem' }}>
                        <Button text="Generate New Contract" intent="primary" disabled={this.disableGenerate()} onClick={() => this.onLeaseGenerationSelection('new-lease')} />
                        <RHFCheckbox
                            style={{verticalAlign: 'middle'}}
                            label="Provisional"
                            name="isProvisional"
                            onClick={this.handleProvisionalCheckBoxChange}
                        />
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default LeasingOwnerSearch;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/LeasingOwnerSearch.tsx